import { cva } from 'class-variance-authority'

export const styles = cva(
  `
    block
    max-w-full
  `,
  {
    variants: {
      aspectRatio: {
        '1/1': 'aspect-[1/1]',
        '16/9': 'aspect-[16/9]',
        '4/3': 'aspect-[4/3]',
        '3/2': 'aspect-[3/2]',
        '21/9': 'aspect-[21/9]',
      },
      objectFit: {
        cover: 'object-cover',
        contain: 'object-contain',
        fill: 'object-fill',
        none: 'object-none',
        scaleDown: 'object-scale-down',
      },
    },
    defaultVariants: {
      objectFit: 'cover',
    },
  }
)
